import React from 'react'
import { useState, useRef } from 'react'
import { Link } from 'react-router-dom'
import Field from './Field'
import { toast } from 'react-toastify'
import { registerCompany } from './../services/Company/index'
import { Container, Form, Button } from 'react-bootstrap'

function SignUp() {
    const [inputValues, setInputValues] = useState({ name: '', alias: '', firstname: '', lastname: '', email: '', apiKey: '' })
    const [btnClicked, setBtnClicked] = useState(false)
    const formRef = useRef()

    const inputChangeHandler = (e) => {
        setInputValues({
            ...inputValues,
            [e.target.name]: e.target.value.trimStart()
        });
    }

    const clearInputValues = () => {
        for (const input of formRef.current.querySelectorAll('input')) {
            input.value = ''
        }
        setInputValues({ name: '', alias: '', firstname: '', lastname: '', email: '', apiKey: '' })
    }

    const registerBtnHandler = async () => {
        if (btnClicked)
            return
        setBtnClicked(true)
        try {
            for (const key in inputValues) {
                if (inputValues[key].length === 0)
                    throw new Error(`${key} field is empty`)
            }
            const resp = await registerCompany(inputValues)
            if (resp.success) {
                clearInputValues()
                toast.success('Company registered successfully')
            }
            else
                throw new Error(resp.error)
        } catch (error) {
            toast.error(error.message)
        }
        setBtnClicked(false)
    }

    const onEnterHandler = (e) => {
        if (e.key === 'Enter' && !btnClicked)
            registerBtnHandler()
    }

    return (
        <Container>
            <h3 className='text-center mb-4'>Register your company</h3>
            <Form ref={formRef}>
                <Field onEnterHandler={onEnterHandler} labelText='Company Name' name='name' placeholder='Enter Company Name' inputChangeHandler={inputChangeHandler} />
                <Field onEnterHandler={onEnterHandler} labelText='Alias' name='alias' placeholder='Enter Company Alias' inputChangeHandler={inputChangeHandler} />
                <Field onEnterHandler={onEnterHandler} labelText='First Name' name='firstname' placeholder='Enter First Name' inputChangeHandler={inputChangeHandler} />
                <Field onEnterHandler={onEnterHandler} labelText='Last Name' name='lastname' placeholder='Enter Last Name' inputChangeHandler={inputChangeHandler} />
                <Field onEnterHandler={onEnterHandler} labelText='Email' name='email' type='email' placeholder='Enter Email' inputChangeHandler={inputChangeHandler} />
                <Field onEnterHandler={onEnterHandler} labelText='API Key' name='apiKey' placeholder='Enter API Key' inputChangeHandler={inputChangeHandler} />
                <div className='text-center'>
                    <Button disabled={btnClicked} variant='success' className='mb-2' onClick={registerBtnHandler}>
                        Register
                    </Button>
                    <p>Already have an account? <Link to='/' className='text-decoration-none'>Sign In here</Link></p>
                </div>
            </Form>
        </Container>
    )
}

export default SignUp